import { Map, List } from "immutable";

import {
  DashboardStatsMapper,
  WorkScheduleTimeSeriesMapper,
  CardMapper,
} from "features/planner/planner.mappers";

import { EMPTY_MAP, EMPTY_LIST } from "app/app.constants";
import { ACTIONS } from "features/planner/report/report.constants";

const initialState = Map({
  stats: EMPTY_MAP,
  workScheduleOverride: EMPTY_MAP,
  modalEmployees: EMPTY_LIST,
});

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_DASHBOARD_REPORT_STATS: {
      if (error) return state;

      return state.set("stats", DashboardStatsMapper.from(payload));
    }

    case ACTIONS.GET_WORK_SCHEDULE_OVERRIDE_TIMESERIES: {
      if (error) return state;

      return state.set(
        "workScheduleOverride",
        WorkScheduleTimeSeriesMapper.from(payload),
      );
    }

    case ACTIONS.GET_EMPLOYEES_BY_EMPLOYEE_TYPE_AND_CARD_CONTAINER_TYPE:
    case ACTIONS.GET_AVAILABLE_PERSONNEL_ONSHORE_BY_COUNTRY:
    case ACTIONS.GET_PERSONNEL_ONSHORE_WITH_REQUIRED_TIMEOFF_BY_COUNTRY: {
      if (error) return state;

      return state.set("modalEmployees", List(payload).map(CardMapper.from));
    }

    default:
      return state;
  }
};
